import { render, staticRenderFns } from "./AuthorityGroupModify.vue?vue&type=template&id=4e686cde&"
import script from "./AuthorityGroupModify.vue?vue&type=script&lang=ts&"
export * from "./AuthorityGroupModify.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports